<script setup lang="ts">
  import { FormFieldContainer, InputField, UiButton } from '@logistiek-zonder-papier/lzp-library'
  import { router } from '@/router'

  const username = defineModel<string>('username')
  const password = defineModel<string>('password')
  const emit = defineEmits(['submit'])
  const props = defineProps<{
    isSubmitting: boolean
    errorMessage: {
      username?: string | undefined
      password?: string | undefined
      general?: string | undefined
    }
  }>()
</script>

<template>
  <FormFieldContainer label="Gebruikersnaam" :error="props.errorMessage.username">
    <InputField
      id="email"
      v-model="username"
      :error="!!props.errorMessage.username"
      autofocus
      type="text"
      placeholder="Voer uw gebruikersnaam in"
      required
      @keyup.enter="emit('submit')"
    />
  </FormFieldContainer>
  <FormFieldContainer label="Wachtwoord" :error="props.errorMessage.password">
    <InputField
      id="password"
      v-model="password"
      :error="!!props.errorMessage.password"
      type="password"
      placeholder="Voer uw wachtwoord in"
      required
      @keyup.enter="emit('submit')"
    />
  </FormFieldContainer>
  <p v-if="props.errorMessage.general" class="error">{{ props.errorMessage.general }}</p>
  <div class="button-group">
    <UiButton
      :disabled="props.isSubmitting"
      variant="prominent"
      type="submit"
      label="Inloggen"
      @click="emit('submit')"
    />
    <UiButton
      label="Wachtwoord vergeten?"
      variant="link"
      @click="router.push('/forgot-password')"
    />
  </div>
</template>

<style scoped>
  .button-group {
    display: flex;
    justify-content: space-between;
    gap: var(--spacing-xs);
  }
  .error {
    color: var(--colours-support-negative);
  }
</style>
